import { gql } from 'graphql-tag';

export const REMOVE_HOLD_EVENT = gql`
  mutation removeHoldEvent($machineId: String!, $eventId: String!) {
    removeHoldEvent(machineId: $machineId, eventId: $eventId) {
      status
    }
  }
`;
